import { render, staticRenderFns } from "./AskModal.vue?vue&type=template&id=3136ef1c&scoped=true"
import script from "./AskModal.vue?vue&type=script&lang=ts"
export * from "./AskModal.vue?vue&type=script&lang=ts"
import style0 from "./AskModal.vue?vue&type=style&index=0&id=3136ef1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3136ef1c",
  null
  
)

export default component.exports